export const mockMembers = [
  { first_name: 'Theo', last_name: 'Smith', member_uuid: '123', has_access: true },
  { first_name: 'Daniel', last_name: 'Smith', member_uuid: '1234', has_access: true },
  { first_name: 'Sunny', last_name: 'Smith', member_uuid: '12354', has_access: false },
  { first_name: 'Chris', last_name: 'Smith', member_uuid: '12365', has_access: false },
];
